<script lang="ts">
import { defineComponent } from 'vue'
import MenuItemsContainer from './menu-items-container/MenuItemsContainer.vue'
import LogoComponent from './Logo.vue'
import LogoSymbolOnly from './LogoSymbolOnly.vue'
import DashboardsMenu from './dashboards-menu/DashboardsMenu.vue'
import { appSidebarCSS } from '@/models/'
import type { INavigationItem } from '@/models'
import type { ISidebarProps } from './sidebar.interface'
defineComponent({
  name: 'Sidebar',
})
</script>

<script setup lang="ts">
defineProps<ISidebarProps>()

const emits = defineEmits<{
  (e: 'menuItemClicked', value: INavigationItem): any
  (e: 'expandOrCollapse', value: INavigationItem): any
  (e: 'toggleSidebarCollapsed'): any
}>()

const onExpandItemClick = (item: INavigationItem) => {
  emits('expandOrCollapse', item)
}

const onMenuItemClicked = (item: INavigationItem) => {
  emits('menuItemClicked', item)
}

const onToggleDesktopSidebarCollapsed = () => {
  emits('toggleSidebarCollapsed')
}
</script>

<template>
  <div :class="appSidebarCSS.wrapper" style="backdrop-filter: blur(2px)">
    <div :class="appSidebarCSS.logoWrapper">
      <button
        data-testid="btn-desktop-menu"
        type="button"
        :class="appSidebarCSS.logoWrapperButton"
        @click.prevent="onToggleDesktopSidebarCollapsed"
      >
        <!-- <span class="sr-only">
          {{ translate('labels.openSidebar') }}
        </span> -->
        <LogoSymbolOnly
          v-if="isCollapsed"
          :brandConfig="config.brand"
          :className="appSidebarCSS.logoSymbolCss"
        />
        <LogoComponent v-if="!isCollapsed" :brandConfig="config.brand" :className="appSidebarCSS.logoCss" />
      </button>
    </div>
    <nav :class="appSidebarCSS.navWrapper" aria-label="Sidebar">
      <div class="flex flex-col gap-2 px-3">
        <DashboardsMenu
          :model="dashboardMenuItem"
          :isCollapsed="isCollapsed"
          @expandOrCollapse="onExpandItemClick"
          @menuItemClicked="onMenuItemClicked"
        />
        <MenuItemsContainer
          v-for="item of navigationItems"
          :key="item.name"
          :model="item"
          :isCollapsed="isCollapsed"
          @expandOrCollapse="onExpandItemClick"
          @menuItemClicked="onMenuItemClicked"
        />
      </div>
      <div class="pt-2">
        <!-- <div class="flex flex-col gap-2 px-3">
          <a
            v-for="item in secondaryNavigationItems"
            :key="item.name"
            :href="item.href"
            class="group flex items-center px-2 py-2 text-sm leading-6 font-medium rounded-md text-cyan-100 hover:text-white hover:bg-cyan-600"
          >
            <component :is="item.icon" class="mr-4 h-6 w-6 text-cyan-200" aria-hidden="true" />
            {{ item.name }}
          </a>
        </div> -->
        <div :class="appSidebarCSS.navBottomMenuContainerWrapper">
          <MenuItemsContainer
            v-for="item in secondaryNavigationItems"
            :key="item.name"
            :model="item"
            :isCollapsed="isCollapsed"
            @menuItemClicked="onMenuItemClicked"
          />
        </div>
      </div>
    </nav>
  </div>
</template>
